var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.showWindow)?_c('div',{staticClass:"container-window"},[_c('div',{staticClass:"content",class:_vm.isShow ? 'content-active' : 'content-default'},[_c('i',{staticClass:"el-icon el-icon-error",on:{"click":_vm.onClose}}),_c('img',{attrs:{"src":_vm.$store.state.userInfo.window.imgurl,"alt":""},on:{"click":_vm.onView}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }